/* 5.39 Proof Hero video. BDS §07 autoplay fences: preload none until within 400px,
   play only above 35% visible, pause off screen and on tab blur, nothing autoplays
   under prefers-reduced-motion (poster stands; the button can still start it). */
(function () {
  var roots = document.querySelectorAll('[data-bp-video]');
  if (!roots.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  roots.forEach(function (root) {
    var v = root.querySelector('video');
    var btn = root.querySelector('[data-bp-toggle]');
    var label = root.querySelector('[data-bp-label]');
    var segs = Array.prototype.slice.call(root.querySelectorAll('.bp-hero__seg'));
    if (!v) return;
    var idle = label ? label.textContent : '';
    var wanted = !reduce;
    var visible = false;
    function load() { if (!v.src) { v.src = v.getAttribute('data-src'); v.load(); } }
    function setBtn(playing) {
      if (!btn) return;
      btn.textContent = playing ? 'PAUSE.' : 'PLAY.';
      btn.setAttribute('aria-label', playing ? 'Pause the film' : 'Play the film');
    }
    function play() {
      load();
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      v.classList.add('is-on');
      setBtn(true);
    }
    function pause() { v.pause(); setBtn(false); }
    setBtn(wanted);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { if (e[0].isIntersecting) load(); }, { rootMargin: '400px 0px' }).observe(root);
      new IntersectionObserver(function (e) {
        visible = e[0].intersectionRatio >= 0.35;
        if (visible && wanted) play(); else v.pause();
      }, { threshold: [0, 0.35] }).observe(root);
    } else if (wanted) { play(); }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) v.pause(); else if (visible && wanted) play();
    });
    if (btn) btn.addEventListener('click', function () {
      if (v.paused) { wanted = true; play(); } else { wanted = false; pause(); }
    });
    v.addEventListener('timeupdate', function () {
      var t = v.currentTime, on = -1;
      segs.forEach(function (s, i) { if (t >= parseFloat(s.getAttribute('data-start'))) on = i; });
      segs.forEach(function (s, i) { s.classList.toggle('is-on', i === on); });
      if (label) label.textContent = on >= 0 ? segs[on].getAttribute('data-label') : idle;
    });
  });
})();
